/**
 * Makes card number look like "0000 0000 0000 0000"
 * Allows to pass more 16 numbers (casual visa/mastercard).
 * *tip (credit cards can have 13-19 numbers)
 */
const normalizeCardNumber = (
  value: string,
  { max }: { max: number } = { max: 19 }, // 19 (4x4) or 23 (4x4 + 1x3)
): string =>
  value
    /** remove all non-numbers (incl. spaces) */
    .replace(/\D+/g, "")
    /** group by 4 elements */
    .match(/.{1,4}/g)
    /** join groups with spaces, like "1111 1111 1111 1111" */
    ?.join(" ")
    /** limit by "max" symbols */
    ?.substring(0, max) || "";

export default normalizeCardNumber;
